const messages = {
    en: {
        maps: {
            zone: {
                name: 'Zone',
                title: 'Zone management',
                subtitle: 'View, search, create, edit and delete Zone',
                creating: 'Creating Zone',
                editing: 'Editing Zone',
                deleting: 'Deleting Zone',
                showing: 'Showing Zone',
                menu: 'Zone',
                labels: {
                    name: 'Name',
                    color: 'Color',
                    value: 'Value'
                },
                determiningZone: "Determining zone"
            }
        }
    },
    es: {
        maps: {
            zone: {
                name: 'Zona',
                title: 'Administración de Zone',
                subtitle: 'Ver, buscar, crear, editar, y borrar Zone',
                creating: 'Creando Zone',
                editing: 'Modificando Zone',
                deleting: 'Eliminando Zone',
                showing: 'Detalles de Zone',
                menu: 'Zona',
                labels: {
                    name: 'Nombre',
                    color: 'Color',
                    value: 'Valor'
                },
                determiningZone: "Determinando zona"

            }
        }
    },
    pt: {
        maps: {
            zone: {
                name: 'Zona',
                title: 'Administração de Zone',
                subtitle: 'Ver, buscar, criar, editar e usar Zone',
                creating: 'Criando Zone',
                editing: 'Edição Zone',
                deleting: 'Apagando Zone',
                showing: 'Detalhes do Zone',
                menu: 'Zona',
                labels: {
                    name: 'Nome',
                    color: 'Color',
                    value: 'Value'
                },
                determiningZone: "Determining zone"

            }
        }
    }
}

export default messages
